export default {
  communities: [],
  community: null,
  unreadCount: 0,
  trendingCommunityId: null,
  trendingPosts: []
};
